<template>
    <router-link
        v-if="target === '_self'"
        :to="href"
        :class="classes"
        v-html="label"
    ></router-link>
    <a v-else :class="classes" :href="href" :target="target" v-html="label"></a>
</template>

<script>
export default {
    name: "LinkBlock",
    props: {
        label: {
            type: String,
            required: true,
            default: '',
        },
        href: {
            type: String,
            required: true,
            default: '',
        },
        target: {
            type: String,
            required: false,
            default: '_self',
        },
        classes: {
            type: String,
            required: false,
            default: '',
        },
    },
}
</script>
